import styled from "styled-components";
import tick from "../../../assets/images/tick.png";

export const ContainerLeft = styled.div`
  top: 3rem;
  width: 50%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  left: 16%;
  padding: 35px;
  & li {
    list-style: none;
    font-size: 16px;
    font-weight: 400;
    margin: 0 0 16px;
    margin-bottom: 1rem;
  }
  @media only screen and (max-width: 767px) {
    width: 100%;
    left: 1%;
    order: 2;
  }
  @media only screen and (min-width: 768px) and (max-width: 1440px) {
    left: 1%;
    width: 45%;
  }
`;

export const DiscountHeader = styled.h1`
  color: #66d7d1;
  font-size: 2.9rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  font-family: Raleway, sans-serif;
  padding: 3px;
  @media only screen and (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const DiscountDueDate = styled.p`
  color: #66d7d1;
  font-size: 1.4rem;
  margin: 0 0 22px;
  font-weight: 600;
  font-family: Raleway, sans-serif;
  padding: 0 0 2px 0;
  margin-top: 20px;
`;

export const DiscountFooter = styled.h4`
  font-size: 18px;
  margin: 0 0 22px;
  font-weight: 300;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const Advantages = styled.ul`
  padding: 0px;
  line-height: 1.4rem;
`;

export const List = styled.li`
  &:before {
    width: 21px;
    content: "";
    height: 12px;
    margin-right: 6px;
    display: inline-block;
    background-repeat: no-repeat;
    background-image: url(${tick});
  }
`;
